import { render, staticRenderFns } from "./TaskServices.vue?vue&type=template&id=57f7a6e4&scoped=true&"
import script from "./TaskServices.vue?vue&type=script&lang=ts&"
export * from "./TaskServices.vue?vue&type=script&lang=ts&"
import style0 from "./TaskServices.vue?vue&type=style&index=0&id=57f7a6e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f7a6e4",
  null
  
)

export default component.exports